<div class="pag-container">
  <div class="ui-g-12 prova">
    <app-challenge-3-kontable #activeChallengesList [columns]="[
                { field: 'title', title: 'challenge.title', filterType: textFilter },
                { field: 'dateStart', title: 'challenge.dateStart', type: 'date', filterType: dateFilter,bodyTemplate: dateStartTemplate },
                { field: 'dateEnd', title: 'challenge.dateEnd', type: 'date', filterType: dateFilter,bodyTemplate: dateEndTemplate },
                { field: 'distributionListName', title: 'challenge.targetList', filterType: textFilter },
                { field: 'numLevelReached', title: 'challenge.numLevelReached', filterType: textFilter, bodyTemplate: numLevelReachedTemplate },
                { field: 'flgAgreementRequired', title: 'challenge.challengeKind', filterType: selectFilter, filterOptions: {values:agreementOptions}, bodyTemplate: flgAgreementRequiredTemplate },
                { field: 'challengeProgress', title: 'challenge.status', filterType: selectFilter, filterOptions: {values:statusOptions}, bodyTemplate: statusProgressTemplate }
            ]" [customerId]="customerId" [service]="challengeService" [paginationType]="paginationType"
                              [showRecoverButton]="false" [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false"
                              [showDetailsButton]="false" [showEditButton]="false" [filterBySingleColumn]="false"
                              [additionalRowCommands]="actions" [showGlobalFilter]="true" [expandTable]="true"
                              [subjectToLoad]="pageSubject" [filterStartDate]="startDate" [filterEndDate]="endDate"
                              (onClearFilters)="clearDateFields()" [customExpandedRowTemplate]="customTemplate"
                              [fetchChallengeListAsap]="true">

      <ng-template #customTemplate let-challengeDetailList="challengeDetailList"
                   let-challengeDetailListElaborated="challengeDetailListElaborated" let-row>
        <ng-container *ngIf="challengeDetailList">
          <app-active-challenges-levels [challengeDetailList]="challengeDetailList"
                                        [fatherChallenge]="row"
                                        (refreshClusterList)="refreshClusterViaKontable(row)">
          </app-active-challenges-levels>
        </ng-container>
      </ng-template>

      <ng-template #flgAgreementRequiredTemplate let-row>
                <span class="center-number">
                    {{ row.flgAgreementRequired === '1' ? 'Sì' : 'No' }}
                </span>
      </ng-template>

      <ng-template #numLevelReachedTemplate let-row>
        <span class="center-number">{{ row.numLevelReached }}</span>
      </ng-template>

      <ng-template #statusProgressTemplate let-row>
                <span class="center-number">
                    <span class="status-dot" [ngClass]="statusColors[row.challengeProgress]"></span>
                    {{ statusLabels[row.challengeProgress] }}
                </span>
      </ng-template>

      <ng-template #dateStartTemplate let-row>
            <span class="center-number">
                {{ row.dateStart | date:'dd/MM/yyyy' }}
            </span>
      </ng-template>

      <ng-template #dateEndTemplate let-row>
            <span class="center-number">
                {{ row.dateEnd | date:'dd/MM/yyyy' }}
            </span>
      </ng-template>
    </app-challenge-3-kontable>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/challenge/challengeinfo.component.html